module.exports = __webpack_public_path__ + "static/media/saved-search-active.f56dd851.svg";